import createFormSlice from '@/store/reducers/createFormSlice';
import { sendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '@/api/apiConfig';
import { createSlice } from '@reduxjs/toolkit';
import { AddDomainFormTypes } from '@/store/types/addDomainFormTypes';
import { handleResponseError } from '@/core/utils/handleResponseError';
import { apiUrl } from '@/api/axios';
import { fetchDomainsListData } from '@/store/reducers/domainsListSlice';
import type { AppDispatch } from '@/store/store';

const addDomainFormData: AddDomainFormTypes = {
	domain: '',
};

const addDomainSlice = createFormSlice('addDomainForm', addDomainFormData);

const combinedSlice = createSlice({
	name: 'addDomainForm',
	initialState: addDomainSlice.getInitialState(),
	reducers: {
		...addDomainSlice.caseReducers,
		checkDomainSuccess(state) {
			state.successMessage = 'Domain is valid and ready to be added.';
		},
	},
});

export const { resetSuccessMessage, setError, checkDomainSuccess } = combinedSlice.actions;

export const checkDomainBeforeAdd = (domain: string) => async (dispatch: AppDispatch) => {
	try {
		const response = await apiUrl.get(`${API_ENDPOINTS.checkDomain}${domain}`);
		if (response.status === 200) {
			dispatch(checkDomainSuccess());
			return true;
		} else {
			throw new Error('Domain validation failed');
		}
	} catch (error) {
		handleResponseError(error, (errorMessage) => dispatch(setError(errorMessage)));
		return false;
	}
};

export const sendDomain = (data: AddDomainFormTypes) => async (dispatch: AppDispatch) => {
	const isDomainValid = await dispatch(checkDomainBeforeAdd(data.domain));
	if (!isDomainValid) {
		return undefined;
	}

	// sendForm возвращает axios-response при успехе и `undefined` при ошибке
	// (см. core/utils/sendFormData.ts). Обновляем список доменов только если
	// POST реально прошёл — иначе UI просто покажет ошибку формы, а список
	// останется прежним.
	const response = await dispatch(sendForm(combinedSlice, API_ENDPOINTS.postNewDomain, '')(data));
	if (response) {
		await dispatch(fetchDomainsListData());
	}
	return response;
};

export default combinedSlice.reducer;
export { combinedSlice as addDomainSlice };
